/**
 * 驳回弹框
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './detailModal.module.scss';
import http from '@/assets/api/http';
import { Modal, message, Form, Input, Checkbox, Button } from 'antd';
import * as apis from '@/apis/finance/transportCompanyWallet';

const detailModal = (props) => {
  const { closeMode, detailInfo } = props

  const [confirmLoading, setConfirmLoading] = useState(false);

  const footer = () => {
    return (
      <Button onClick={closeMode}>关闭</Button>
    )
  }

  const toRemark = (req) => {
    return req ? req : '-'
  }

  return (
    <Modal
      width={890}
      centered
      title='账户信息'
      visible={true}
      confirmLoading={confirmLoading}
      onOk={closeMode}
      onCancel={closeMode}
      destroyOnClose={true}
      keyboard={true}
      maskClosable={false}
      footer={footer()}
    >
      <div className={styles.modalContent}>
        <div>
          <div>
            <label>小运力名称：</label>
            <div>{toRemark(detailInfo.transportName)}</div>
          </div>
          <div>
            <label>企业类型：</label>
            <div>{toRemark(detailInfo.orgType)}</div>
          </div>
          <div>
            <label>营业执照开始日期：</label>
            <div>{toRemark(detailInfo.bizLicStartDate)}</div>
          </div>
          <div>
            <label>法人姓名：</label>
            <div>{toRemark(detailInfo.legalName)}</div>
          </div>
          <div>
            <label>法人证件类型：</label>
            <div>{toRemark(detailInfo.legalIdType)}</div>
          </div>
          <div>
            <label>法人证件有效期开始日期：</label>
            <div>{toRemark(detailInfo.legalIdCardStartDate)}</div>
          </div>
          <div>
            <label>银行账户类型：</label>
            <div>{toRemark(detailInfo.bankAcctType)}</div>
          </div>
          <div>
            <label>开户行名称：</label>
            <div>{toRemark(detailInfo.bankName)}</div>
          </div>
          <div>
            <label>结算账号：</label>
            <div>{toRemark(detailInfo.settAcctNo)}</div>
          </div>
          <div>
            <label>电子账户名称：</label>
            <div>{toRemark(detailInfo.bwalletAcctName)}</div>
          </div>
          <div>
            <label>注册状态：</label>
            <div>{toRemark(detailInfo.regStatus)}</div>
          </div>
        </div>
        <div>
          <div>
            <label>小运力ID：</label>
            <div>{toRemark(detailInfo.transportId)}</div>
          </div>
          <div>
            <label>营业执照号码：</label>
            <div>{toRemark(detailInfo.bizLicNo)}</div>
          </div>
          <div>
            <label>营业执照结束日期：</label>
            <div>{toRemark(detailInfo.bizLicEndDate)}</div>
          </div>
          <div>
            <label>法人电话：</label>
            <div>{toRemark(detailInfo.legalPhoneNum)}</div>
          </div>
          <div>
            <label>法人身份证号：</label>
            <div>{toRemark(detailInfo.legalIdCard)}</div>
          </div>
          <div>
            <label>法人证件结束效期：</label>
            <div>{toRemark(detailInfo.legalIdCardEndDate)}</div>
          </div>
          <div>
            <label>结算账户名称：</label>
            <div>{toRemark(detailInfo.settAcctName)}</div>
          </div>
          <div>
            <label>开户行支行名称：</label>
            <div>{toRemark(detailInfo.elecBankName)}</div>
          </div>
          <div>
            <label>电子账户注册时间：</label>
            <div>{toRemark(detailInfo.regTime)}</div>
          </div>
          <div>
            <label>电子账户ID：</label>
            <div>{toRemark(detailInfo.bwalletId)}</div>
          </div>
          <div>
            <label>备注：</label>
            <div>{toRemark(detailInfo.bgLog)}</div>
          </div>
        </div>
      </div>
    </Modal>
  );

}

detailModal.propTypes = {
  detailInfo: PropTypes.object, // 弹框入参
  closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
  title: PropTypes.string,// 弹框标题
};

export default detailModal;